import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentforpuneairport() {



    const cardData =
    {
        keyword: 'Urbania On Rent for Pune Airport',
        heading: 'Urbania on rent in pune: Urbania On Rent for Pune Airport',
        headingDescription: 'Urbania On Rent in Pune provides reliable and comfortable Urbania On Rent for Pune Airport transfers for corporate groups, families, tourists, and event travelers. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and ample luggage space, making it ideal for airport pickups and drops, corporate travel, and group transfers to and from Pune Airport. With professional chauffeurs, flexible one-way and round-trip rental options, and timely doorstep pickup from all major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and nearby locations, we ensure punctual and stress-free airport travel. Backed by 24/7 booking support, flight-tracking assistance, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for Urbania hire for Pune Airport transfers.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania on Rent for Pune Airport",
      "description": "Urbania on Rent for Pune Airport provides reliable and comfortable vehicles for airport transfers. Whether it’s for domestic or international flights, passengers can enjoy timely pickups, spacious seating, and professional chauffeurs to ensure a stress-free travel experience to or from Pune Airport."
    },
    {
      "name": "Pune Airport Urbania Hire",
      "description": "Pune Airport Urbania Hire offers flexible vehicle rental options for airport commutes. With air-conditioned vehicles, trained drivers, and organized scheduling, it ensures passengers reach the airport or city destinations safely, punctually, and comfortably."
    },
    {
      "name": "Urbania Bus Rental Pune Airport",
      "description": "Urbania Bus Rental Pune Airport provides large buses for group airport transfers, corporate teams, and social gatherings. With spacious seating, ample luggage capacity, and professional drivers, it guarantees a convenient and stress-free journey to and from Pune Airport."
    },
    {
      "name": "Urbania AC Airport Transfer Pune",
      "description": "Urbania AC Airport Transfer Pune offers fully air-conditioned vehicles for comfortable airport commutes. With trained chauffeurs, timely pickups, and reliable service, passengers experience a smooth, pleasant, and professional transfer to domestic or international flights."
    },
    {
      "name": "Corporate Airport Transfer Urbania Pune",
      "description": "Corporate Airport Transfer Urbania Pune provides organized transportation for executives, employees, and corporate clients traveling to or from Pune Airport. Vehicles are well-maintained, equipped with air-conditioning, and driven by professional chauffeurs to ensure punctual and comfortable travel."
    },
    {
      "name": "Group Airport Transfer Urbania Pune",
      "description": "Group Airport Transfer Urbania Pune delivers efficient and comfortable airport transportation for large groups, families, or corporate teams. With spacious vehicles, ample luggage space, and experienced drivers, it ensures a seamless and hassle-free airport transfer experience."
    },
    {
      "name": "Luxury Airport Urbania Pune",
      "description": "Luxury Airport Urbania Pune offers premium, high-end vehicles for airport transfers. Featuring plush interiors, air-conditioning, and professional chauffeurs, it guarantees a stylish, comfortable, and stress-free travel experience for VIPs, business executives, and special occasions."
    },
    {
      "name": "Affordable Airport Urbania Hire Pune",
      "description": "Affordable Airport Urbania Hire Pune provides cost-effective and reliable airport transportation without compromising on comfort or service. Vehicles are spacious, well-maintained, and driven by experienced chauffeurs, making it ideal for individuals, families, and groups seeking economical airport transfers."
    },
    {
      "name": "Chauffeur Driven Airport Urbania Pune",
      "description": "Chauffeur Driven Airport Urbania Pune ensures a stress-free and safe transfer to and from Pune Airport. With verified and trained drivers, clean and spacious vehicles, and punctual service, passengers can relax and enjoy a comfortable journey without worrying about navigation or traffic."
    },
    {
      "name": "Urbania for Pickup and Drop Pune Airport",
      "description": "Urbania for Pickup and Drop Pune Airport provides round-trip airport transportation services for passengers. With organized scheduling, professional chauffeurs, and reliable vehicles, it ensures smooth pickups and drops, whether for early morning flights or late-night arrivals."
    },
    {
      "name": "Pune Airport to City Urbania Hire",
      "description": "Pune Airport to City Urbania Hire offers quick and comfortable transfers from the airport to various locations within Pune city. With trained drivers, spacious vehicles, and timely service, it ensures passengers reach their city destinations efficiently and comfortably."
    },
    {
      "name": "Reliable Airport Urbania Service Pune",
      "description": "Reliable Airport Urbania Service Pune focuses on punctuality, safety, and comfort for airport transfers. With well-maintained vehicles, professional chauffeurs, and organized scheduling, passengers can depend on a smooth and hassle-free travel experience to or from Pune Airport."
    },
    {
      "name": "Best Airport Urbania Rental Pune",
      "description": "Best Airport Urbania Rental Pune delivers top-rated airport transfer services known for reliability, professionalism, and vehicle quality. Ideal for individual travelers, families, and corporate clients, it ensures a safe, comfortable, and stress-free journey to and from Pune Airport."
    },
    {
      "name": "Urbania for International Airport Transfer Pune",
      "description": "Urbania for International Airport Transfer Pune specializes in providing timely and comfortable transfers for international flights. With air-conditioned vehicles, trained chauffeurs, and ample luggage space, it guarantees a convenient and professional airport travel experience."
    },
    {
      "name": "Urbania Group Airport Travel Pune",
      "description": "Urbania Group Airport Travel Pune provides organized airport transportation for large groups, including families, friends, and corporate teams. With spacious vehicles, professional drivers, and reliable scheduling, it ensures a smooth, safe, and comfortable airport transfer experience."
    }
  ],
  "tableData": [
    ["Urbania on Rent for Pune Airport", "Pune Airport Urbania Hire"],
    ["Urbania Bus Rental Pune Airport", "Urbania AC Airport Transfer Pune"],
    ["Corporate Airport Transfer Urbania Pune", "Group Airport Transfer Urbania Pune"],
    ["Luxury Airport Urbania Pune", "Affordable Airport Urbania Hire Pune"],
    ["Chauffeur Driven Airport Urbania Pune", "Urbania for Pickup and Drop Pune Airport"],
    ["Pune Airport to City Urbania Hire", "Reliable Airport Urbania Service Pune"],
    ["Best Airport Urbania Rental Pune", "Urbania for International Airport Transfer Pune"],
    ["Urbania Group Airport Travel Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent for Pune Airport",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport is perfect for comfortable and timely airport transfers for families, groups, and corporate travelers."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport provides well-maintained Force Urbania vehicles with ample seating and luggage space for a smooth and hassle-free airport journey."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport comes with skilled drivers familiar with Pune city and airport routes, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent for Pune Airport for competitive rates with no hidden charges, making airport transfers reliable and budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport provides round-the-clock assistance for bookings, flight updates, and last-minute airport travel needs."
    },
    {
        "WhyChooseheading": "Flexible Airport Transfer Packages",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport offers one-way, round-trip, and hourly packages to suit your airport travel requirements."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania On Rent for Pune Airport are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent for Pune Airport guarantees timely pickups and dependable service, ensuring stress-free travel to and from the airport."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent for Pune Airport suitable for one-way and round trips?',
        answer: 'Yes, Urbania On Rent for Pune Airport is available for one-way, round-trip, and hourly airport transfers.',
    },
    {
        question: 'How can I book Urbania On Rent for Pune Airport?',
        answer: 'You can book Urbania On Rent for Pune Airport via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent for Pune Airport for airport transfers?',
        answer: 'Urbania On Rent for Pune Airport offers spacious seating, comfortable rides, ample luggage space, and professional drivers, making it ideal for airport travel.',
    },
    {
        question: 'Are the drivers experienced with Urbania On Rent for Pune Airport?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for airport transfers.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania On Rent for Pune Airport?',
        answer: 'Absolutely. Urbania On Rent for Pune Airport allows flexible pickup and drop-off locations across Pune city and surrounding areas.',
    },
    {
        question: 'Is Urbania On Rent for Pune Airport available 24x7?',
        answer: 'Yes, Urbania On Rent for Pune Airport operates 24x7 to accommodate flight schedules and travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania On Rent for Pune Airport?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for airport travel.',
    },
    {
        question: 'What payment options are available for Urbania On Rent for Pune Airport?',
        answer: 'Urbania On Rent for Pune Airport accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free airport transfer.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Saurabh Patil',
        feedback: 'We booked Urbania for a Pune airport transfer. The vehicle was spacious, clean, and the driver was punctual. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Joshi',
        feedback: 'Urbania On Rent for Pune Airport made our airport travel smooth and stress-free. Highly recommended for families and corporate travelers.',
        rating: 5,
    },
];




































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent for Pune Airport",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-airport-transfer-pune.jpg",
  "description": "Urbania On Rent for Pune Airport offers AC and non-AC Urbania buses for airport transfers, including pickup and drop services, corporate transfers, group travel, and luxury transfers. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation to and from Pune Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-for-pune-airport"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent for Pune Airport | AC & Luxury Urbania Airport Transfer 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent for Pune Airport for pickup, drop, corporate transfers, group travel, and luxury airport transfers. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation to and from Pune Airport."
  />

  <meta
    name="keywords"
    content="Urbania on Rent for Pune Airport, Pune Airport Urbania Hire, Urbania Bus Rental Pune Airport, Urbania AC Airport Transfer Pune, Corporate Airport Transfer Urbania Pune, Group Airport Transfer Urbania Pune, Luxury Airport Urbania Pune, Affordable Airport Urbania Hire Pune, Chauffeur Driven Airport Urbania Pune, Urbania for Pickup and Drop Pune Airport, Pune Airport to City Urbania Hire, Reliable Airport Urbania Service Pune, Best Airport Urbania Rental Pune, Urbania for International Airport Transfer Pune, Urbania Group Airport Travel Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentforpuneairport;